function init() {
  document.querySelectorAll('[data-event-card-video]').forEach(el => {
    el.addEventListener('mouseover', () => {
      const video = el.querySelector('video');
      video.play();
    });
    el.addEventListener('mouseout', () => {
      const video = el.querySelector('video');
      video.pause();
    });
  });
}

export default { init };
